module.exports = __webpack_public_path__ + "img/news-2.53b342c.webp";